import { useContext, useEffect } from 'react';
import { AnnotationUpdateEvent } from '@atlaskit/editor-common/types';
import { ProvidersContext } from '../context';
import { RendererContext as ActionsContext } from '../../RendererActionsContext';
export const useLoadAnnotations = ({
  adfDocument,
  isNestedRender
}) => {
  const actions = useContext(ActionsContext);
  const providers = useContext(ProvidersContext);
  useEffect(() => {
    if (!providers) {
      return;
    }
    const {
      inlineComment: {
        getState: inlineCommentGetState,
        updateSubscriber: updateSubscriberInlineComment
      }
    } = providers;
    const annotations = actions.getAnnotationMarks();
    // we don't want to request integrators for state with an empty list of ids.
    if (!annotations.length) {
      return;
    }
    const ids = annotations.map(mark => mark.attrs.id);
    const cb = data => {
      if (!updateSubscriberInlineComment) {
        return;
      }
      const payload = data.reduce((acc, value) => ({
        ...acc,
        [value.id]: value
      }), {});
      updateSubscriberInlineComment.emit(AnnotationUpdateEvent.SET_ANNOTATION_STATE, payload);
    };
    inlineCommentGetState(ids, isNestedRender).then(cb);
  }, [actions, providers, adfDocument, isNestedRender]);
};